<div class="row m-2">
  <div *ngFor="let providerOffice of providerOffices" class="col-4">
    <app-provider-office [providerOffice]="providerOffice" />
  </div>
</div>
